import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Typography,
  Box,
  Divider,
  Tooltip,
} from "@mui/material";
import { MdAccountCircle } from "react-icons/md";
import { FiMenu, FiLogOut, FiUser, FiX } from "react-icons/fi";
import { AiOutlineHome } from "react-icons/ai";
import { BsPeople, BsGear } from "react-icons/bs";
import { FaChartBar, FaChartLine, FaFileAlt, FaCreditCard } from "react-icons/fa";
import { RiListView, RiInformationFill } from "react-icons/ri";
import logoImg from "../assets/sporless-logo.png";
import axios from "../utils/api";
import "./Header.css";

// Sidebar icon color per menu label (each icon gets a distinct color)
const SIDEBAR_ICON_COLORS = {
  Home: "#2563eb",
  Analysis: "#7c3aed",
  "Employee Data": "#059669",
  "Global Settings": "#d97706",
  Subscription: "#db2777",
  "DAR-Analysis": "#4f46e5",
  "Data-Collection Form": "#0d9488",
  "View Data-Collection": "#0284c7",
  "Employee-Leave": "#ea580c",
};

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userDetails, setUserDetails] = useState({
    email: null,
    name: null,
    role: null,
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);

    if (token) {
      const fetchUserDetails = async () => {
        try {
          const email = localStorage.getItem("email");
          const response = await axios.get(`getemail-admin-details/${email}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          setUserDetails({
            email: response.data.email,
            name: response.data.name,
            role: response.data.role,
          });
        } catch (error) {
          console.error("Error fetching details:", error);
        }
      };

      fetchUserDetails();
    }
  }, []);

  const navigate = useNavigate();

  const handleLogout = () => {
    // Remove auth-related items explicitly
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("email");
      // also clear sessionStorage if used anywhere
      try { sessionStorage.clear(); } catch (e) { /* ignore */ }

      // remove any axios default auth header set by utils
      try {
        if (axios && axios.defaults && axios.defaults.headers) {
          delete axios.defaults.headers.common["Authorization"];
        }
      } catch (e) {
        // ignore if axios shape is different
      }

      setIsLoggedIn(false);
      // navigate to login route (SPA-friendly)
      navigate("/login");
      // as a fallback force a reload to ensure state reset
      // window.location.reload();
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  const toggleSidebar = (open) => () => {
    setSidebarOpen(open);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const   roleBasedMenu = {
    Hr: [
      { path: "/card", label: "Home", icon: <AiOutlineHome size={20} /> },
      {
        path: "/disinfection-analysis",
        label: "Analysis",
        icon: <FaChartLine size={20} />,
      },
      {
        path: "/Employeecard",
        label: "Employee Data",
        icon: <BsPeople size={20} />,
      },
      {
        path: "/card-global",
        label: "Global Settings",
        icon: <BsGear size={20} />,
      },
      {
        path: "/subscription",
        label: "Subscription",
        icon: <FaCreditCard size={20} />,
      },
      {
        path: "/dar-List",
        label: "DAR-Analysis",
        icon: <FaChartBar size={20} />,
      },
      {
        path: "/DataFormCard",
        label: "Data-Collection Form",
        icon: <FaFileAlt size={20} />,
      },
      {
        path: "/dataviewcard",
        label: "View Data-Collection",
        icon: <RiListView size={20} />,
      },
      {
        path: "/LeaveCard",
        label: "Employee-Leave",
        icon: <RiInformationFill size={20} />,
      }
    ],
    ProjectManager: [
      { path: "/card", label: "Home", icon: <AiOutlineHome size={20} /> },
      {
        path: "/disinfection-analysis",
        label: "Analysis",
        icon: <FaChartLine size={20} />,
      },
      {
        path: "/Employeecard",
        label: "Employee Data",
        icon: <BsPeople size={20} />,
      },
      {
        path: "/card-global",
        label: "Global Settings",
        icon: <BsGear size={20} />,
      },
      {
        path: "/subscription",
        label: "Subscription",
        icon: <FaCreditCard size={20} />,
      },
      {
        path: "/dar-List",
        label: "DAR-Analysis",
        icon: <FaChartBar size={20} />,
      },
      {
        path: "/DataFormCard",
        label: "Data-Collection Form",
        icon: <FaFileAlt size={20} />,
      },
      {
        path: "/dataviewcard",
        label: "View Data-Collection",
        icon: <RiListView size={20} />,
      },
      {
        path: "/LeaveCard",
        label: "Employee-Leave",
        icon: <RiInformationFill size={20} />,
      }
    ],
    AdminController: [
      { path: "/card", label: "Home", icon: <AiOutlineHome size={20} /> },
      {
        path: "/disinfection-analysis",
        label: "Analysis",
        icon: <FaChartLine size={20} />,
      },
      {
        path: "/Employeecard",
        label: "Employee Data",
        icon: <BsPeople size={20} />,
      },
      {
        path: "/card-global",
        label: "Global Settings",
        icon: <BsGear size={20} />,
      },
      {
        path: "/LeaveCard",
        label: "Employee-Leave",
        icon: <RiInformationFill size={20} />,
      }
    ],
    Distributor: [
      {
        path: "/disinfection-analysis",
        label: "Analysis",
        icon: <FaChartLine size={20} />,
      },
      {
        path: "/dar-List",
        label: "DAR-Analysis",
        icon: <FaChartBar size={20} />,
      },
      {
        path: "/DataFormCard",
        label: "Data-Collection Form",
        icon: <FaFileAlt size={20} />,
      },
      {
        path: "/dataviewcard",
        label: "View Data-Collection",
        icon: <RiListView size={20} />,
      },
      {
        path: "/Employeecard",
        label: "Employee Data",
        icon: <BsPeople size={20} />,
      },
    ],
  };

  return (
    <>
    <header style={styles.header} className="header-glass">
      {/* Main Header Container */}
      <div style={styles.headerContainer} className="header-container">
        {/* Left - Logo Section */}
        <div style={styles.logoSection}>
          <Link to="/content" style={styles.logoLink}>
            <img src={logoImg} alt="SpotlessAI Logo" style={styles.logoImage} />
          </Link>
        </div>

        {/* Right - User Actions */}
        <div style={styles.actionsSection} className="actions-section">
          {/* User Profile */}
          <div style={styles.userProfile} onClick={handleDialogOpen}>
            <Avatar
              style={styles.avatar}
              sx={{
                background: "linear-gradient(to right, #3B82F6 0%, #EC4899 100%)",
                cursor: "pointer",
              }}
            >
              {userDetails.name?.charAt(0) || <FiUser size={20} />}
            </Avatar>
            <div style={styles.userInfo} className="user-info">
              <Typography variant="body2" style={styles.userName}>
                {userDetails.name || "User"}
              </Typography>
              <Typography variant="caption" style={styles.userRole}>
                {userDetails.role}
              </Typography>
            </div>
          </div>

          {/* Menu Button */}
          <Tooltip title="Menu" placement="bottom">
            <IconButton onClick={toggleSidebar(true)} style={styles.menuButton} className="focusable">
              <FiMenu size={24} color="white" />
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {/* Animated Gradient Line */}
      <div style={styles.gradientLine} className="gradient-line">
        <div style={styles.animatedGradient}></div>
      </div>

      {/* Modern Sidebar Drawer */}
      <Drawer
        anchor="right"
        open={sidebarOpen}
        onClose={toggleSidebar(false)}
        PaperProps={{
          sx: {
            background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
            backdropFilter: "blur(20px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
            width: { xs: "100vw", sm: "320px" },
          },
        }}
      >
        <Box style={styles.sidebarContainer} className="sidebar-container sidebar-glass">
          {/* Sidebar Header */}
          <div style={styles.sidebarHeader}>
            <IconButton
              onClick={toggleSidebar(false)}
              style={styles.sidebarCloseButton}
              className="focusable"
              aria-label="Close sidebar"
            >
              <FiX size={18} color="white" />
            </IconButton>
            <div style={styles.sidebarProfileSection}>
              <Avatar
                style={styles.sidebarAvatar}
                sx={{
                  background:
                    "linear-gradient(to right, #3B82F6 0%, #EC4899 100%)",
                  width: 60,
                  height: 60,
                  fontSize: "1.5rem",
                  marginBottom: 2,
                }}
              >
                {userDetails.name?.charAt(0) || <MdAccountCircle size={30} />}
              </Avatar>
              <Typography variant="h6" style={styles.sidebarUserName}>
                {userDetails.name}
              </Typography>
              <Typography variant="body2" style={styles.sidebarUserRole}>
                {userDetails.role}
              </Typography>
            </div>
          </div>

          <Divider
            sx={{
              margin: "20px 0",
              backgroundColor: "rgba(100, 116, 139, 0.2)",
            }}
          />

          {/* Navigation Menu */}
          <div style={styles.navigationSection}>
            <Typography variant="subtitle2" style={styles.menuSectionTitle}>
              NAVIGATION
            </Typography>
            <List style={styles.menuList}>
              {roleBasedMenu[userDetails.role]?.map((menuItem, index) => (
                <ListItem
                  button
                  key={index}
                  component={Link}
                  to={menuItem.path}
                  onClick={toggleSidebar(false)}
                  style={styles.menuItem}
                  className="menu-item-hover"
                  sx={{
                    borderRadius: "12px",
                    margin: "4px 0",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #667eea20 0%, #764ba220 100%)",
                      transform: "translateX(8px)",
                      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                    },
                  }}
                >
                  <ListItemIcon
                    style={{
                      ...styles.menuIcon,
                      color: SIDEBAR_ICON_COLORS[menuItem.label] ?? "#64748b",
                    }}
                  >
                    {React.cloneElement(menuItem.icon, {
                      color: SIDEBAR_ICON_COLORS[menuItem.label] ?? "#64748b",
                    })}
                  </ListItemIcon>
                  <ListItemText
                    primary={menuItem.label}
                    primaryTypographyProps={{
                      style: styles.menuItemText,
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </div>

          {/* Logout Section */}
          {isLoggedIn && (
            <div style={styles.logoutSection}>
              <Button
                style={styles.modernLogoutButton}
                onClick={handleLogout}
                startIcon={<FiLogOut size={16} />}
                sx={{
                  background:
                    "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "9px 18px",
                  textTransform: "none",
                  fontWeight: 600,
                  width: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 25px rgba(239, 68, 68, 0.3)",
                  },
                }}
              >
                Sign Out
              </Button>
            </div>
          )}
        </Box>
      </Drawer>

      {/* Enhanced Profile Dialog — light theme */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        className="profile-dialog"
        PaperProps={{
          className: "profile-dialog-paper",
          sx: {
            borderRadius: "20px",
            background: "#ffffff",
            boxShadow: "0 25px 50px rgba(102, 126, 234, 0.12)",
            border: "1px solid rgba(102, 126, 234, 0.15)",
            minWidth: "360px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          className="profile-dialog-title"
          sx={{
            background: "linear-gradient(135deg, rgba(59, 130, 246, 0.06) 0%, rgba(236, 72, 153, 0.08) 100%)",
            textAlign: "center",
            padding: "24px",
            borderRadius: "20px 20px 0 0",
            borderBottom: "1px solid rgba(102, 126, 234, 0.12)",
          }}
        >
          <Avatar
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#ffffff",
              width: 60,
              height: 60,
              fontSize: "1.5rem",
              margin: "0 auto 16px auto",
              fontWeight: 700,
              boxShadow: "0 8px 24px rgba(102, 126, 234, 0.35)",
            }}
          >
            {userDetails.name?.charAt(0) || <MdAccountCircle size={30} />}
          </Avatar>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: "1.125rem",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Profile Information
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: "24px 20px", background: "#ffffff" }}>
          <div style={styles.profileDialogContent}>
            <div style={styles.profileField}>
              <Typography variant="subtitle2" style={styles.fieldLabel}>
                Full Name
              </Typography>
              <Typography variant="body1" style={styles.fieldValue}>
                {userDetails.name}
              </Typography>
            </div>
            <div style={styles.profileField}>
              <Typography variant="subtitle2" style={styles.fieldLabel}>
                Email Address
              </Typography>
              <Typography variant="body1" style={styles.fieldValue}>
                {userDetails.email}
              </Typography>
            </div>
            <div style={styles.profileField}>
              <Typography variant="subtitle2" style={styles.fieldLabel}>
                Role & Permissions
              </Typography>
              <Typography variant="body1" style={styles.fieldValue}>
                {userDetails.role}
              </Typography>
            </div>
          </div>
        </DialogContent>
        <DialogActions
          className="profile-dialog-actions"
          sx={{
            padding: "8px 24px 20px",
            justifyContent: "center",
            background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
            borderTop: "1px solid rgba(226, 232, 240, 0.9)",
          }}
        >
          <Button
            className="profile-dialog-close-btn"
            onClick={handleDialogClose}
            sx={{
              background: "linear-gradient(to right, #3B82F6 0%, #EC4899 100%)",
              color: "#ffffff",
              borderRadius: "10px",
              padding: "10px 30px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "0 4px 15px rgba(59, 130, 246, 0.35)",
              border: "none",
              "&:hover": {
                background: "linear-gradient(to right, #2563eb 0%, #db2777 100%)",
                boxShadow: "0 8px 25px rgba(236, 72, 153, 0.35)",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </header>
    <div style={styles.headerSpacer} />
    </>
  );
};

const styles = {
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    zIndex: 1100,
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(20px)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.8)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
  },
  headerSpacer: {
    height: "72px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 24px",
    maxWidth: "100%",
    margin: "0 auto",
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  logoLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    gap: "16px",
    transition: "all 0.3s ease",
    backgroundColor: "#475569",
    padding: "8px 14px",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(15, 23, 42, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.08)",
  },
  logoImage: {
    height: "38px",
    width: "auto",
    display: "block",
    borderRadius: "6px",
    transition: "all 0.3s ease",
  },
  brandText: {
    display: "flex",
    flexDirection: "column",
  },
  brandTitle: {
    fontWeight: 700,
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: "1.5rem",
    lineHeight: 1.2,
  },
  brandSubtitle: {
    color: "#64748b",
    fontWeight: 500,
    fontSize: "0.875rem",
  },
  centerSection: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pageTitle: {
    color: "#1e293b",
    fontWeight: 600,
    fontSize: "1.25rem",
  },
  actionsSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    justifyContent: "flex-end",
  },
  notificationButton: {
    padding: "8px",
    borderRadius: "12px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(100, 116, 139, 0.1)",
      transform: "translateY(-2px)",
    },
  },
  userProfile: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "6px 12px",
    borderRadius: "16px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    border: "1px solid rgba(226, 232, 240, 0.8)",
    background: "rgba(248, 250, 252, 0.5)",
    "&:hover": {
      background: "rgba(248, 250, 252, 0.8)",
      border: "1px solid rgba(102, 126, 234, 0.3)",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
    },
  },
  avatar: {
    width: 34,
    height: 34,
    fontSize: "0.9rem",
    fontWeight: 600,
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  userName: {
    fontWeight: 600,
    color: "#1e293b",
    fontSize: "0.875rem",
    lineHeight: 1.2,
  },
  userRole: {
    color: "#64748b",
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  menuButton: {
    background: "linear-gradient(to right, #3B82F6 0%, #EC4899 100%)",
    borderRadius: "12px",
    padding: "8px",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(59, 130, 246, 0.35)",
    "&:hover": {
      background: "linear-gradient(to right, #2563eb 0%, #db2777 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(236, 72, 153, 0.4)",
    },
  },
  gradientLine: {
    height: "4px",
    width: "100%",
    background: "linear-gradient(to right, #3B82F6 0%, #EC4899 100%)",
    position: "relative",
    overflow: "hidden",
  },
  animatedGradient: {
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
    animation: "shimmer 3s infinite",
  },
  sidebarContainer: {
    width: "320px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "0",
    overflow: "hidden",
  },
  sidebarHeader: {
    padding: "32px 24px 20px 24px",
    background: "linear-gradient(to right, #3B82F6 0%, #EC4899 100%)",
    borderRadius: 12,
    color: "white",
    position: "relative",
  },
  sidebarCloseButton: {
    position: "absolute",
    top: "10px",
    left: "10px",
    background: "rgba(255, 255, 255, 0.15)",
    borderRadius: "8px",
    padding: "5px",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.25)",
      transform: "scale(1.05)",
    },
  },
  sidebarProfileSection: {
    textAlign: "center",
  },
  sidebarAvatar: {
    margin: "0 auto 16px auto",
  },
  sidebarUserName: {
    fontWeight: 700,
    color: "white",
    marginBottom: "4px",
    fontSize: "1.25rem",
  },
  sidebarUserRole: {
    color: "rgba(255, 255, 255, 0.8)",
    fontWeight: 500,
    fontSize: "0.875rem",
  },
  navigationSection: {
    flex: 1,
    padding: "24px",
    minHeight: 0,
    overflowY: "auto",
  },
  menuSectionTitle: {
    color: "#64748b",
    fontWeight: 700,
    fontSize: "0.75rem",
    letterSpacing: "0.1em",
    marginBottom: "16px",
    textTransform: "uppercase",
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    padding: "12px 16px",
    color: "#475569",
  },
  menuIcon: {
    color: "#667eea",
    minWidth: "40px",
  },
  menuItemText: {
    fontWeight: 500,
    fontSize: "0.875rem",
  },
  logoutSection: {
    padding: "24px",
    borderTop: "1px solid rgba(226, 232, 240, 0.8)",
  },
  modernLogoutButton: {
    borderRadius: "12px",
    padding: "9px 18px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.8rem",
  },
  profileDialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "10px",
  },
  profileField: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  fieldLabel: {
    marginTop: "6px",
    color: "#64748b",
    fontWeight: 600,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },
  fieldValue: {
    color: "#1e293b",
    fontWeight: 500,
    fontSize: "0.95rem",
    padding: "10px 14px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    borderRadius: "10px",
    border: "1px solid rgba(102, 126, 234, 0.18)",
    width: "92%",
    alignSelf: "center",
  },

  // CSS Keyframes (will need to be added to global CSS)
  "@keyframes shimmer": {
    "0%": { left: "-100%" },
    "100%": { left: "100%" },
  },

  // Responsive styles
  "@media (max-width: 768px)": {
    headerContainer: {
      padding: "12px 16px",
    },
    logoSection: {
      flex: "0 0 auto",
    },
    brandText: {
      display: "none",
    },
    centerSection: {
      display: "none",
    },
    actionsSection: {
      gap: "8px",
    },
    userInfo: {
      display: "none",
    },
    sidebarContainer: {
      width: "280px",
    },
  },
};

export default Header;
